import { ReactElement } from 'react'
import DriverTransactionList from '../../components/Driver/transactions'
import Layout from '../../components/layout'

const DriverTransactionPage = (): ReactElement => {
  return (
    <Layout>
      <DriverTransactionList />
    </Layout>
  )
}

export default DriverTransactionPage
